/**
 * 구독(`channel_subscription`) 이 월 M(YYYY-MM)에 **과금되는지** — 서버
 * `ChannelSubscriptionService.billableIn` 과 같은 규칙이어야 한다(다르면 화면과 청구서가 어긋난다).
 *
 *     effectiveFrom <= M <= effectiveTo(없으면 ∞)
 *     and ( status = ACTIVE  or  (status = ENDED and effectiveTo 있음) )
 *
 * 🔴 2026-10-01 — 종래에는 `status === 'ACTIVE'` 만 봤다. '종료' 버튼은 종료월을 넣으면서 status 를
 * ENDED 로 바꾸므로, **종료월(포함)이 그 달이어도 구독료가 청구서에서 빠졌다**(9-04 시작·9월 종료 →
 * 9월 청구서에 설치비만). ENDED 의 뜻은 "종료월 **다음 달부터** 청구하지 않는다" 이다.
 * 종료월이 비어 있는 ENDED 는 언제 끝났는지 알 수 없으므로 청구하지 않는다(서버와 동일).
 */
export const isBillableForMonth = (s, m) => {
  if (!s || !m) return false;
  const inRange = s.effectiveFrom <= m && (!s.effectiveTo || s.effectiveTo >= m);
  if (!inRange) return false;
  return s.status === 'ACTIVE' || (s.status === 'ENDED' && !!s.effectiveTo);
};

/** '종료' 프롬프트 문구 — 종료월이 청구에 포함된다는 것을 입력하는 순간 알려준다. */
export const END_MONTH_PROMPT =
  '종료월(YYYY-MM)을 입력하세요.\n\n입력한 달까지 구독료가 청구되고(첫 유료일이 그 달이면 일할), 다음 달부터 빠집니다.';
